/* eslint-disable import/prefer-default-export */
export const CONFIRMATION_DIALOGS = {
  schedule: 'schedule',
  reschedule: 'reschedule',
  cancel: 'cancel',
};
